import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from './stores/authStore';
import analyticsService from './services/analyticsService';
import LoginPage from './components/auth/LoginPage';
import GalleryPage from './components/gallery/GalleryPage';

function App() {
  const { isAuthenticated, restoreSession, user, galleryId, sessionId } = useAuthStore();

  useEffect(() => {
    // Try to restore session on app load
    restoreSession();
  }, [restoreSession]);

  useEffect(() => {
    if (!isAuthenticated || !user || !galleryId || !sessionId) return;

    const handlePageExit = () => {
      void analyticsService.endSession(user, galleryId, sessionId);
    };

    window.addEventListener('pagehide', handlePageExit);
    window.addEventListener('beforeunload', handlePageExit);

    return () => {
      window.removeEventListener('pagehide', handlePageExit);
      window.removeEventListener('beforeunload', handlePageExit);
    };
  }, [galleryId, isAuthenticated, sessionId, user]);

  return (
    <Router>
      <div className="min-h-screen bg-gray-50">
        <Routes>
          <Route
            path="/login"
            element={
              isAuthenticated ? <Navigate to="/gallery" replace /> : <LoginPage />
            }
          />
          <Route
            path="/gallery"
            element={
              isAuthenticated ? <GalleryPage /> : <Navigate to="/login" replace />
            }
          />
          <Route
            path="/"
            element={<Navigate to={isAuthenticated ? "/gallery" : "/login"} replace />}
          />
          <Route
            path="*"
            element={<Navigate to="/" replace />}
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
